import { render, staticRenderFns } from "./StockList.vue?vue&type=template&id=24b5fabd&"
import script from "./StockList.vue?vue&type=script&lang=js&"
export * from "./StockList.vue?vue&type=script&lang=js&"
import style0 from "./StockList.vue?vue&type=style&index=0&id=24b5fabd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports